export type PickerSize = 'small' | 'medium' | 'large';

export const pickerOptionSizeClasses = {
  small: 'py-0.5 text-sm',
  medium: 'py-1.5 text-sm',
  large: 'py-2 text-base',
};

export const pickerTriggerIconSizeClasses = {
  small: '[&_svg]:size-4.5',
  medium: '[&_svg]:size-5',
  large: '[&_svg]:size-6',
};
